export default __webpack_public_path__ + "media/images/features/hida/hida-city-fd22e3c99eda2febfe18abf8bc1d6e8a.png";